import { render, staticRenderFns } from "./services_component.vue?vue&type=template&id=bda7993c&scoped=true&"
import script from "./services_component.vue?vue&type=script&lang=js&"
export * from "./services_component.vue?vue&type=script&lang=js&"
import style0 from "./services_component.vue?vue&type=style&index=0&id=bda7993c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda7993c",
  null
  
)

export default component.exports